module.exports = "/_next/static/images/5e1f8074523ed53a70354d1756077748-slide-1-small.png.webp";